<p-table
  [value]="getDiffTable()"
  stripedRows
  [scrollable]="true"
  scrollHeight="flex"
  class="p-datatable-sm lp-table">
  <ng-template pTemplate="header">
    <tr>
      <th style="font-size: 15px">Felt</th>
      <th style="font-size: 15px">Revision {{ getRevisionInfo()[0] }}</th>
      <th style="font-size: 15px">Revision {{ getRevisionInfo()[1] }}</th>
    </tr>
  </ng-template>
  <ng-template [appTableRow]="getDiffTable()" pTemplate="body" let-d>
    <tr>
      <td>
        <div
          [style]="{
            paddingLeft: d.level * 10 + 'px',
            fontWeight: d.fontWeight,
            fontSize: d.fontSize + 'rem',
          }">
          {{ d.label }}
        </div>
      </td>
      <td>{{ d.oldValue }}</td>
      <td>{{ d.newValue }}</td>
    </tr>
  </ng-template>
</p-table>
